export const CORRELATION_ID_HEADER = 'x-correlation-id';
